import { tw } from '@/utils/tw';
import BaseBreakingNewsTheme from 'base/components/BreakingNews/theme';

const BreakingNews = tw.theme({
  extend: BaseBreakingNewsTheme,
  variants: {
    variant: {
      primary: {
        base: ``,
        item: `bg-linen-200`,
        blip: `bg-gold before:bg-gold after:bg-gold`,
        headline: `text-black text-preamble-sm sm:text-preamble-sm`,
        label: `!font-extrabold text-black text-preamble-sm sm:text-preamble-sm`,
      },
    },
  },
});

export default BreakingNews;
